import apiClient from './apiClient'

// All calls go through apiClient, which attaches the bearer token and refreshes on 401.

/** The current authenticated user (identity comes from the access token). */
export async function getCurrentUser() {
    const { data } = await apiClient.get('/users/me')
    return data
}

/** Public profile card: { username, bio, profilePicture }. */
export async function getPublicUser(username) {
    const { data } = await apiClient.get(`/users/${username}`)
    return data
}

/**
 * Username availability. Returns a [available, message] tuple to match the onboarding UI.
 * The endpoint is authenticated, so it's only meaningful during the (protected) setup flow.
 */
export async function checkUsernameAvailability(username) {
    try {
        const { data } = await apiClient.get('/users/username-available', { params: { username } })
        return data.available ? [true, 'Looks good!'] : [false, 'That username is taken']
    } catch (err) {
        const message = err.response?.data?.error || 'Invalid username'
        return [false, message]
    }
}

/** Claims a handle and finishes setup; returns the updated user (didCompleteSetup === true). */
export async function setUsername(username) {
    const { data } = await apiClient.put('/users/me/username', { username })
    return data
}

/** Updates the bio; returns the updated user. */
export async function updateBio(bio) {
    const { data } = await apiClient.put('/users/me/bio', { bio })
    return data
}

/** Uploads a new avatar (multipart 'file'); returns the updated user — read `.profilePicture`. */
export async function uploadProfilePicture(formData) {
    const { data } = await apiClient.post('/users/me/profile-picture', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data
}

/** Removes the avatar (204). */
export async function removeProfilePicture() {
    await apiClient.delete('/users/me/profile-picture')
}
